import React, { ReactElement } from 'react';
import TreasureWithMagazine from './TreasureWithMagazine';

function ThreeDStage(): ReactElement {
	return (
		<div className="StageGlass">
			<TreasureWithMagazine />
		</div>
	);
}

export default ThreeDStage; 